/** 動画からポスターフレームを切り出す（同時実行を絞って AV1 デコードの詰まりを防ぐ） */
const cache = new Map();
const queue = [];
let running = 0, MAX = 2;

/** もう要らなくなって捨てた印。呼び出し側が「失敗」と区別して取り直せるようにする */
export const SKIPPED = Symbol('skipped');

/** 待ち行列にいる間だけ持つ。同じ絵を欲しがる別のカードを相乗りさせるため */
const waiting = new Map();

/**
 * @param {() => boolean} wanted 取り出す直前に呼ぶ。どの依頼元も要らなくなっていれば
 *   デコードせず SKIPPED を返す。スクロールで溜まった順番待ちが、
 *   いま見ているカードの前に居座るのを防ぐ。
 */
export function poster(url, t, w = 256, wanted = () => true){
  const key = `${url}@${t.toFixed(2)}`;
  // 描き直しの前後で同じ絵を頼むと、待ち行列には古いカードの wanted しか無い。
  // 相乗りさせないと、まだ見えている新しいカードの分まで捨ててしまう。
  const job = waiting.get(key);
  if(job){ job.wanted.push(wanted); return cache.get(key); }
  if(cache.has(key)) return cache.get(key);
  const p = new Promise(resolve => {
    const j = { key, url, t, w, wanted: [wanted], resolve };
    waiting.set(key, j);
    queue.push(j);
  });
  cache.set(key, p);
  pump();
  return p;
}

function pump(){
  while(running < MAX && queue.length){
    const job = queue.shift();
    waiting.delete(job.key);
    if(!job.wanted.some(f => f())){ cache.delete(job.key); job.resolve(SKIPPED); continue; }
    running++;
    grab(job).then(job.resolve).finally(() => { running--; pump(); });
  }
}

function grab({ url, t, w }){
  return new Promise(resolve => {
    const v = document.createElement('video');
    let settled = false;
    const done = (out) => {
      if(settled) return;
      settled = true;
      clearTimeout(timer);
      v.removeAttribute('src'); v.load();
      resolve(out);
    };
    const timer = setTimeout(() => done(null), 15000);
    v.muted = true; v.playsInline = true; v.preload = 'auto'; v.crossOrigin = 'anonymous';
    v.addEventListener('loadedmetadata', () => { v.currentTime = Math.min(t, Math.max(0, v.duration - 0.05)); }, { once: true });
    v.addEventListener('seeked', () => {
      try {
        const c = document.createElement('canvas');
        c.width = w; c.height = Math.round(w * (v.videoHeight || 3) / (v.videoWidth || 4));
        c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
        c.toBlob(b => done(b ? URL.createObjectURL(b) : null), 'image/jpeg', 0.72);
      } catch { done(null); }
    }, { once: true });
    v.addEventListener('error', () => done(null), { once: true });
    v.src = url;
  });
}

export function clearPosters(){
  for(const p of cache.values())
    p.then(u => u && u !== SKIPPED && URL.revokeObjectURL(u)).catch(() => {});
  cache.clear(); queue.length = 0; waiting.clear();
}
